import * as types from "../constants/action-types";

const initialState = {
  isMenuOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_MENU:
      return Object.assign({}, state, {
        isMenuOpen: !state.isMenuOpen
      });
    case types.CLOSE_MENU:
      return Object.assign({}, state, {
        isMenuOpen: false
      });
    case "@@router/LOCATION_CHANGE":
      return Object.assign({}, state, {
        isMenuOpen: false
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ui.js